import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [openModal]);
  const closeModal = () => setOpenModal(null);
  return <>
      <footer className="bg-navy-900 border-t border-navy-700 py-12 px-4 text-center relative z-10" data-id="element-44">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-45">
          <p className="text-gold-500 font-heading text-xl mb-6" data-id="element-46">
            Kinesiotaping Clínico Pro
          </p>
          <p className="text-cream-200/60 text-sm" data-id="element-47">
            Una producción de Impulso Vital
          </p>
          <p className="text-cream-200/60 text-sm" data-id="element-48">
            Edición Digital Premium — Acceso inmediato tras la compra
          </p>
          <p className="text-cream-200/60 text-sm" data-id="element-49">
            Garantía de satisfacción total
          </p>

          <div className="flex flex-wrap justify-center gap-4 pt-6 text-sm" data-id="element-50">
            <button onClick={() => setOpenModal('privacy')} className="text-cream-200/60 hover:text-gold-400 transition-colors underline-offset-4 hover:underline" data-id="element-51">
              Política de Privacidad
            </button>
            <span className="text-navy-700" data-id="element-52">•</span>
            <button onClick={() => setOpenModal('terms')} className="text-cream-200/60 hover:text-gold-400 transition-colors underline-offset-4 hover:underline" data-id="element-53">
              Términos y Condiciones
            </button>
          </div>

          <div className="pt-8 mt-8 border-t border-navy-800 text-cream-200/40 text-xs" data-id="element-54">
            &copy; {new Date().getFullYear()} Impulso Vital. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-55">
        {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-56">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-57" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5,
          bounce: 0
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-navy-800 border border-navy-700 rounded-sm shadow-2xl flex flex-col overflow-hidden" data-id="element-58">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-navy-700 bg-navy-900/50" data-id="element-59">
                <h2 className="text-2xl font-heading font-bold text-gold-400" data-id="element-60">
                  {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={closeModal} className="p-2 text-cream-200/60 hover:text-cream-100 hover:bg-navy-700 rounded-sm transition-colors" aria-label="Cerrar modal" data-id="element-61">
                  <XIcon className="w-6 h-6" data-id="element-62" />
                </button>
              </div>

              {/* Modal Content - Scrollable */}
              <div className="p-6 sm:p-8 overflow-y-auto custom-scrollbar text-cream-200 space-y-6 text-left" data-id="element-63">
                {openModal === 'privacy' ? <>
                    <p data-id="element-64">
                      En <strong data-id="element-65">Impulso Vital</strong>, respetamos su
                      privacidad y estamos comprometidos a proteger la
                      información personal que comparte con nosotros al adquirir
                      el manual digital <em data-id="element-66">Kinesiotaping Clínico Pro</em>.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-67">
                      1. Recopilación de Datos
                    </h3>
                    <p data-id="element-68">
                      Solo recopilamos la información estrictamente necesaria
                      para procesar su compra, entregar el producto digital y
                      garantizar el acceso al mismo. Esto incluye su nombre,
                      dirección de correo electrónico y detalles de la
                      transacción procesados de forma segura a través de nuestra
                      pasarela de pago. No almacenamos datos sensibles de
                      tarjetas de crédito en nuestros servidores.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-69">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-70">
                      La información recopilada se utiliza exclusivamente para:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-71">
                      <li data-id="element-72">Procesar su pago y entregar el manual digital.</li>
                      <li data-id="element-73">
                        Enviarle recibos, actualizaciones del producto y
                        notificaciones importantes.
                      </li>
                      <li data-id="element-74">
                        Prevenir fraudes y garantizar la seguridad de la
                        plataforma.
                      </li>
                    </ul>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-75">
                      3. Protección y Compartición de Datos
                    </h3>
                    <p data-id="element-76">
                      No vendemos, alquilamos ni compartimos su información
                      personal con terceros para fines comerciales. Sus datos
                      solo se comparten con proveedores de servicios esenciales
                      (como procesadores de pago y plataformas de envío de
                      correos) que operan bajo estrictos acuerdos de
                      confidencialidad.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-77">
                      4. Cookies y Tecnologías de Rastreo
                    </h3>
                    <p data-id="element-78">
                      Utilizamos cookies esenciales para el funcionamiento
                      básico del sitio web y el procesamiento del carrito de
                      compras. No utilizamos cookies invasivas de rastreo
                      publicitario de terceros.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-79">
                      5. Sus Derechos
                    </h3>
                    <p data-id="element-80">
                      Usted tiene derecho a solicitar el acceso, la
                      rectificación o la eliminación de sus datos personales de
                      nuestros registros en cualquier momento.
                    </p>
                  </> : <>
                    <p data-id="element-81">
                      Al adquirir y acceder al manual digital{' '}
                      <em data-id="element-82">Kinesiotaping Clínico Pro</em>, usted acepta los
                      siguientes términos y condiciones establecidos por{' '}
                      <strong data-id="element-83">Impulso Vital</strong>.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-84">
                      1. Propiedad Intelectual
                    </h3>
                    <p data-id="element-85">
                      Todo el contenido incluido en el manual{' '}
                      <em data-id="element-86">Kinesiotaping Clínico Pro</em> (textos, diagramas,
                      imágenes, metodologías) es propiedad intelectual exclusiva
                      de Impulso Vital. La compra le otorga una licencia de uso
                      personal, intransferible y no exclusiva.
                    </p>
                    <p className="text-red-300/90 mt-2" data-id="element-87">
                      <strong data-id="element-88">Queda estrictamente prohibida</strong> la
                      reproducción, distribución, reventa, publicación en
                      internet o compartición no autorizada de este material con
                      terceros.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-89">
                      2. Descargo de Responsabilidad Médica
                    </h3>
                    <p data-id="element-90">
                      Este manual ha sido diseñado con fines estrictamente
                      educativos y formativos para profesionales y estudiantes
                      del área de la salud. La información proporcionada no
                      sustituye el juicio clínico, el diagnóstico profesional ni
                      el consejo médico.
                    </p>
                    <p data-id="element-91">
                      Impulso Vital no se hace responsable por lesiones, daños o
                      consecuencias derivadas de la mala aplicación de las
                      técnicas descritas en el material. El terapeuta es el
                      único responsable de evaluar las contraindicaciones en
                      cada paciente individual.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-92">
                      3. Política de Reembolso y Garantía
                    </h3>
                    <p data-id="element-93">
                      Ofrecemos una garantía de satisfacción total. Si después
                      de revisar el manual completo usted considera que no ha
                      recibido el valor prometido, puede solicitar la devolución
                      íntegra de su inversión dentro del plazo establecido en la
                      oferta comercial, sin preguntas ni burocracia.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-94">
                      4. Acceso y Disponibilidad
                    </h3>
                    <p data-id="element-95">
                      Al realizar la compra, se le otorgará acceso inmediato
                      para la descarga del producto digital. Es su
                      responsabilidad guardar una copia segura del archivo. Vida
                      en Curso se compromete a mantener el enlace de descarga
                      activo durante un período razonable, pero recomendamos
                      descargar el material inmediatamente.
                    </p>

                    <h3 className="text-xl font-heading text-cream-100 mt-8 mb-4" data-id="element-96">
                      5. Modificaciones
                    </h3>
                    <p data-id="element-97">
                      Nos reservamos el derecho de actualizar o modificar estos
                      términos en cualquier momento. Las modificaciones entrarán
                      en vigor inmediatamente después de su publicación.
                    </p>
                  </>}
              </div>

              {/* Modal Footer */}
              <div className="p-6 border-t border-navy-700 bg-navy-900/50 text-right" data-id="element-98">
                <button onClick={closeModal} className="px-6 py-2 bg-navy-700 hover:bg-navy-600 text-cream-100 rounded-sm font-medium transition-colors" data-id="element-99">
                  Entendido
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}